// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import { useDeleteCustomerDetailMutation, useGetAllCustomerDetailMutation } from '../../store/api/customerDetailApi';
import {
  getCustomerDetails,
  getCustomerDetailTotalRecords,
  setCustomerDetail,
} from '../../store/state/customerDetailSlice';
import { checkPermissions } from '../../sections/@dashboard/parkingspaces/utility';
import { useForgotPasswordMutation } from '../../store/api/userApi';
import { getMessage } from '../../components/message';
import { PERMISSION } from '../../utils/userPermission';

const TABLE_HEAD = [
  { id: 'name', label: 'Customer Name', alignRight: false },
  { id: 'email', label: 'Email Address', alignRight: false },
  { id: 'phoneNo', label: 'Phone Number', alignRight: false },
  { id: 'CustomerStatus', label: "Customer's Status", alignRight: false },
  { id: '' },
];

export default function CustomerDetails() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const customerDetailData = useAppSelector(getCustomerDetails);
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const [getAllCustomerDetail, getAllResponse] = useGetAllCustomerDetailMutation();
  const [deleteCustomerDetail, deleteResponse] = useDeleteCustomerDetailMutation();
  const [customerDetail, setCustomerDetails] = useState([]);
  const filteredUsers = customerDetail;
  const isUserNotFound = filteredUsers.length === 0;
  const customerDetailTotalRecords = useAppSelector(getCustomerDetailTotalRecords);
  const [forgetPassword, forgetPasswordResponse] = useForgotPasswordMutation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [itemName, setItemName] = useState('');
  const [filterName, setFilterName] = useState('');
  const [selected, setSelected] = useState([]);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [open, setOpen] = useState(false);
  const [customerId, setCustomerId] = useState<number>();

  useEffect(() => {
    if (customerDetailData) {
      setCustomerDetails(customerDetailData);
    }
  }, [customerDetailData]);

  useEffect(() => {
    getAllCustomerDetail({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        name: itemName,
      },
    });
    setFilterName('');
  }, []);

  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setCustomerDetail(getAllResponse.data));
    }
    if (getAllResponse.isError) {
      let errorData: any = getAllResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllResponse.isSuccess, getAllResponse.isError]);

  useEffect(() => {
    if (deleteResponse.isSuccess) {
      getAllCustomerDetail({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          name: itemName,
        },
      });
      toast.success('Customer updated successfully');
    } else if (deleteResponse.isError) {
      toast.error('Service Exception.');
    }
  }, [deleteResponse.isSuccess, deleteResponse.isError]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    getAllCustomerDetail({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: newPage,
        name: itemName,
      },
    });
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllCustomerDetail({
      token: token.token,
      payload: {
        offset: parseInt(event.target.value, 10),
        page: 0,
        name: itemName,
      },
    });
  };

  const handleFilterByName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterName(event.target.value);
    getAllCustomerDetail({
      token: token.token,
      payload: { offset: rowsPerPage, page: page, name: event.target.value },
    });
  };

  const handleDelete = () => {
    setOpen(false);
    deleteCustomerDetail({
      id: customerId,
      token: token.token,
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  useEffect(() => {
    if (forgetPasswordResponse.isSuccess) {
      toast.success(getMessage.SUCCESS_FORGOT_PASSWORD);
    }

    if (forgetPasswordResponse.isError) {
      toast.error(getMessage.Error_FORGOT_PASSWORD);
    }
  }, [forgetPasswordResponse.isSuccess, forgetPasswordResponse.isError]);

  function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  

  return (
    <Page title="Customer Profile">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            Customer Profile
          </Typography>
        </Stack>
        <Card>
          <BookingListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            placeholder={'Search By Customer Name'}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={customerDetail.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const { id, name, email, phoneNo, userId, status, role, company, avatarUrl, isVerified } = row;
                      const isItemSelected = selected.indexOf(itemName) !== -1;  return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell
                            align="left"
                            onClick={() => {
                              if (!checkPermissions(PERMISSION.CUSTOMER_VIEW, token.permissions)) {
                                navigate('/dashboard/add-or-update-customer', {
                                  state: { editMode: true, id: id },
                                });
                              }
                            }}
                          >
                            <Typography
                              fontWeight="bold"
                              variant="subtitle2"
                              color={checkPermissions(PERMISSION.CUSTOMER_VIEW, token.permissions) ? 'grey' : 'blue'}
                              style={{
                                cursor: checkPermissions(PERMISSION.CUSTOMER_VIEW, token.permissions)
                                  ? 'cursor-text'
                                  : 'pointer',
                              }}
                            >
                              {name ? capitalizeFirstLetter(name) : '_'}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {email ? email : '_'}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {phoneNo ? phoneNo : '_'}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Stack direction="row" alignItems="center">
                              <Switch
                                checked={status}
                                disabled={checkPermissions(PERMISSION.CUSTOMER_VIEW, token.permissions)}
                                onClick={() => {
                                  setCustomerId(id);
                                  handleOpen();
                                }}
                              />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={customerDetailTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {open && (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                Are you sure?
              </Typography>
              <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                <Button
                  variant="contained"
                  onClick={cancelDelete}
                  sx={{ margin: '10px' }}
                  style={{ color: 'white', backgroundColor: '#E23744' }}
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  onClick={handleDelete}
                  sx={{ margin: '10px' }}
                  style={{ color: 'white', backgroundColor: '#E23744' }}
                >
                  Yes
                </Button>
              </Stack>
            </Box>
          </Modal>
        )}
        {getAllResponse.isLoading || deleteResponse.isLoading ? <Loading /> : null}
      </Container>
    </Page>
  );
}
